import React from "react";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import "./CurrencyCard.css";

export default class CurrencyCard extends React.Component{

    render() {
        let mainStyle = {
            display: "flex",
            height: this.props.size ?? 20
        }
        let size = this.props.size ?? 20;
        let fontSize = this.props.fontSize ?? 20;
        let iconStyle = {
            display: "block",
            width: `${size}px`,
            height: `auto`
        }
        let padding = size / 2;
        let textStyle = {
            position: "relative",
            fontWeight: this.props.fontWeight ?? "bold",
            color: this.props.textColor ?? "white",
            fontSize: `${fontSize}px`,
            lineHeight: `${size}px`,
            verticalAlign: "middle",
            paddingLeft: `${padding}px`,
            textTransform: "uppercase",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.5)"
        };

        let markerStyle = {
            height: "14px",
            width: "14px",
            borderRadius: "50%",
            marginRight: "4px"
        }

        return <div title={this.props.title} className={this.props.needsIcons && "currency__with-icons"} style={{
            ...mainStyle,
            ...this.props.style
        }}>
            <img style={iconStyle} src={this.props.icon} alt={"icon"}/>

            {
                this.props.needsIcons ? <div><div style={textStyle} title={this.props.iconTitles[0] || ""} >
                        {this.props.needsIcons && <div className="coal-marker" style={{...markerStyle}}/>}
                        {UtilsFunctions.toPrettyNumber(this.props.value.coal)}
                    </div>
                        <div style={textStyle} title={this.props.iconTitles[1] || ""} >
                            {this.props.needsIcons && <div className="other-marker" style={{...markerStyle}}/>}
                            {UtilsFunctions.toPrettyNumber(this.props.value.other)}
                        </div></div>
                    : <div style={textStyle}>
                        {UtilsFunctions.toPrettyNumber(this.props.value)}
                    </div>
            }

        </div>
    }

}
